document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".initially-hidden").forEach((el) => {
    el.classList.remove("initially-hidden");
  });

  initializeLazyImages();
  initializeThemeMeasurements();
});

// Global lazy image loader with skeleton backgrounds
function initializeLazyImages() {
  const lazyImages = document.querySelectorAll(".lazy-fade");

  if (!lazyImages.length) return;

  lazyImages.forEach((img) => {
    // Add skeleton class to wrapper
    const wrapper = img.closest(".lazy-wrapper");
    if (wrapper) {
      wrapper.classList.add("loading");
    }

    // Check if already loaded
    if (img.complete && img.naturalHeight !== 0) {
      handleImageLoad(img, wrapper);
    } else {
      // Listen for load event
      img.addEventListener("load", function () {
        handleImageLoad(img, wrapper);
      });

      // Handle error
      img.addEventListener("error", function () {
        if (wrapper) {
          wrapper.classList.remove("loading");
          wrapper.classList.add("error");
        }
      });
    }
  });
}

function handleImageLoad(img, wrapper) {
  img.classList.add("loaded");
  if (wrapper) {
    wrapper.classList.remove("loading");
    wrapper.classList.add("loaded");
  }
}

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

function debounceImmediate(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

const html = document.documentElement;

function setElementHeight(element, { heightVar, onUpdate }) {
  if (!element) return;

  const height = element.offsetHeight;

  if (heightVar) {
    html.style.setProperty(heightVar, `${height}px`);
  }

  if (typeof onUpdate === "function") {
    onUpdate(height);
  }
}

function initializeAnnouncement() {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) return;

  const updateAnnouncement = () =>
    setElementHeight(announcementBar, {
      heightVar: "--announcement-height",
      onUpdate: (height) => {
        window.announcementHeight = height;
      },
    });

  updateAnnouncement();

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateAnnouncement);
    observer.observe(announcementBar);
  } else {
    const debouncedAnnouncement = debounce(updateAnnouncement, 300);
    window.addEventListener("resize", debouncedAnnouncement, {
      passive: true,
    });
  }
}

function initializeHeaderHeight() {
  const mainHeader = document.querySelector(".main-header");
  if (!mainHeader) return;

  const updateHeader = () =>
    setElementHeight(mainHeader, {
      heightVar: "--header-height",
      onUpdate: (height) => {
        window.headerHeight = height;
      },
    });

  updateHeader();

  const throttledHeaderUpdate = throttle(updateHeader, 16);
  window.addEventListener("scroll", throttledHeaderUpdate, {
    passive: true,
  });

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateHeader);
    observer.observe(mainHeader);
  } else {
    const debouncedHeaderUpdate = debounce(updateHeader, 150);
    window.addEventListener("resize", debouncedHeaderUpdate, {
      passive: true,
    });
  }
}

function initializeThemeMeasurements() {
  initializeAnnouncement();
  initializeHeaderHeight();
}

// Helper: Calculate luminance (brightness) of a color based on rgb values like this ' 255, 255 , 255 '
function getLuminance(colorStr) {
  const [r, g, b] = colorStr.split(",").map(Number);
  return (r * 299 + g * 587 + b * 114) / 1000; // Weighted luminance
}
